// URL base de la API. En desarrollo se puede sobreescribir con REACT_APP_API_URL (.env.development).
// En produccion apunta siempre a la API de Render.
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://voltaris-api.onrender.com/api';
